// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderDetails-orderCardListContainer-_lzhT {
    display: grid;
    grid-template-columns: repeat(2, calc(50% - 9px));
    gap: 18px;
    grid-gap: 18px;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
}

.OrderDetails-orderLocationBox-hPcNc {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    gap: 3px;
    grid-gap: 3px;
    margin-bottom: 6px;
}

.OrderDetails-orderLocationBox-hPcNc img {
    position: relative;
    top: 4px;
}

.OrderDetails-orderUploadImgContainer-GViVL {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 18px;
    grid-gap: 18px;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
}

.OrderDetails-orderUploadImgCardContainer-_zCEs {
    position: relative;
    background: var(--background-primary);
    z-index: 1;
}

.OrderDetails-orderUploadImgCardPlusIcon-ZWmvv {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
    z-index: -1;
}

.OrderDetails-orderUploadImgCard-CBq8X {
    position: relative;
    border: 1px solid var(--primary-border);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    border-radius: var(--radius-1);
    height: 116px;
    cursor: pointer;
}

.OrderDetails-orderUploadPreviewLoaderContainer-gBMof {
    position: relative;
    width: 100%;
    min-height: 116px;
}

.OrderDetails-photoUpdateLoader-RUchz {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
}

.OrderDetails-photoUpdateLoader-RUchz img {
    width: 72px;
    height: 72px;
}

.OrderDetails-orderUploadPreviewImgItem-pxodP {
    position: relative;
    width: 100%;
    height: 116px;
    border-radius: var(--radius-1);
    border: 1px solid var(--primary-border);
}

.OrderDetails-orderUploadPreviewImg-tKHwd {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: center;
       object-position: center;
    border-radius: inherit;
}

.OrderDetails-orderUploadPreviewOverlay-hkVtf {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border-radius: inherit;
}

.OrderDetails-orderUploadPreviewHoverImg-UvVJm {
    display: none;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 33px;
    height: 32px;
    -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
}

.OrderDetails-orderUploadPreviewImgHover-VuKTr,
.OrderDetails-orderUploadPreviewTextHover-s_VFl {
    cursor: pointer;
}

.OrderDetails-orderUploadPreviewImgHover-VuKTr:hover .OrderDetails-orderUploadPreviewOverlay-hkVtf,
.OrderDetails-orderUploadPreviewTextHover-s_VFl:hover .OrderDetails-orderUploadPreviewOverlay-hkVtf {
    background-color: #00000066;
}

.OrderDetails-orderUploadPreviewImgHover-VuKTr:hover .OrderDetails-orderUploadPreviewHoverImg-UvVJm {
    display: block;
}

.OrderDetails-orderUploadPreviewCountText-s9Uk2 {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
    color: var(--common-primary-white-foreground);
}

.OrderDetails-orderUploadPreviewImgRemoveIcon-ZgMGy {
    position: absolute;
    top: 4px;
    right: 4px;
    background: var(--background-primary);
    -webkit-box-shadow: 0px 4px 4px 0px #0000000F;
            box-shadow: 0px 4px 4px 0px #0000000F;
    width: 24px;
    height: 24px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    cursor: pointer;
    border-radius: 50%;
}

@media (max-width: 1199px) {
    .OrderDetails-orderCardListContainer-_lzhT {
        grid-template-columns: 100%;
        -webkit-box-align: initial;
            -ms-flex-align: initial;
                align-items: initial;
        -webkit-box-pack: initial;
            -ms-flex-pack: initial;
                justify-content: initial;
    }
}

@media (max-width: 1199px) and (min-width: 1081px) {
    .OrderDetails-orderUploadImgContainer-GViVL {
        grid-template-columns: repeat(5, 1fr);
        gap: 12px;
        grid-gap: 12px;
    }
}

@media (max-width: 1080px) and (min-width: 991px) {
    .OrderDetails-orderUploadImgContainer-GViVL {
        grid-template-columns: repeat(4, 1fr);
        gap: 12px;
        grid-gap: 12px;
    }
}

@media (max-width: 991px) and (min-width: 768px) {
    .OrderDetails-orderUploadImgContainer-GViVL {
        grid-template-columns: repeat(5, 1fr);
        gap: 12px;
        grid-gap: 12px;
    }
}

@media (max-width: 767px) and (min-width: 576px) {
    .OrderDetails-orderUploadImgContainer-GViVL {
        grid-template-columns: repeat(4, 1fr);
        gap: 18px;
        grid-gap: 18px;
    }
}

@media (max-width: 575px) {
    .OrderDetails-orderUploadImgContainer-GViVL {
        grid-template-columns: repeat(2, 1fr);
        gap: 18px;
        grid-gap: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/BookingDetail/OrderDetails/OrderDetails.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iDAAwD;IACxD,SAAS;IACT,cAAc;IACd,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;AAC/B;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,QAAQ;IACR,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,cAAc;IACd,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,wCAAgC;QAAhC,oCAAgC;YAAhC,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,uCAAuC;IACvC,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,8BAA8B;IAC9B,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;IACjB,0BAAuB;OAAvB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,wCAAgC;QAAhC,oCAAgC;YAAhC,gCAAgC;AACpC;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,wCAAgC;QAAhC,oCAAgC;YAAhC,gCAAgC;IAChC,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,qCAAqC;IACrC,6CAAqC;YAArC,qCAAqC;IACrC,WAAW;IACX,YAAY;IACZ,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;AACtB;;AAGA;IACI;QACI,2BAA2B;QAC3B,0BAAoB;YAApB,uBAAoB;gBAApB,oBAAoB;QACpB,yBAAwB;YAAxB,sBAAwB;gBAAxB,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,qCAAqC;QACrC,SAAS;QACT,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,qCAAqC;QACrC,SAAS;QACT,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,qCAAqC;QACrC,SAAS;QACT,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,qCAAqC;QACrC,SAAS;QACT,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,qCAAqC;QACrC,SAAS;QACT,cAAc;IAClB;AACJ","sourcesContent":[".orderCardListContainer {\n    display: grid;\n    grid-template-columns: repeat(2, calc((100% / 2) - 9px));\n    gap: 18px;\n    grid-gap: 18px;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n.orderLocationBox {\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 3px;\n    grid-gap: 3px;\n    margin-bottom: 6px;\n}\n\n.orderLocationBox img {\n    position: relative;\n    top: 4px;\n}\n\n.orderUploadImgContainer {\n    display: grid;\n    grid-template-columns: repeat(6, 1fr);\n    gap: 18px;\n    grid-gap: 18px;\n    justify-content: flex-start;\n    align-items: flex-start;\n}\n\n.orderUploadImgCardContainer {\n    position: relative;\n    background: var(--background-primary);\n    z-index: 1;\n}\n\n.orderUploadImgCardPlusIcon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: -1;\n}\n\n.orderUploadImgCard {\n    position: relative;\n    border: 1px solid var(--primary-border);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: var(--radius-1);\n    height: 116px;\n    cursor: pointer;\n}\n\n.orderUploadPreviewLoaderContainer {\n    position: relative;\n    width: 100%;\n    min-height: 116px;\n}\n\n.photoUpdateLoader {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.photoUpdateLoader img {\n    width: 72px;\n    height: 72px;\n}\n\n.orderUploadPreviewImgItem {\n    position: relative;\n    width: 100%;\n    height: 116px;\n    border-radius: var(--radius-1);\n    border: 1px solid var(--primary-border);\n}\n\n.orderUploadPreviewImg {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n    border-radius: inherit;\n}\n\n.orderUploadPreviewOverlay {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    border-radius: inherit;\n}\n\n.orderUploadPreviewHoverImg {\n    display: none;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 33px;\n    height: 32px;\n    transform: translate(-50%, -50%);\n}\n\n.orderUploadPreviewImgHover,\n.orderUploadPreviewTextHover {\n    cursor: pointer;\n}\n\n.orderUploadPreviewImgHover:hover .orderUploadPreviewOverlay,\n.orderUploadPreviewTextHover:hover .orderUploadPreviewOverlay {\n    background-color: #00000066;\n}\n\n.orderUploadPreviewImgHover:hover .orderUploadPreviewHoverImg {\n    display: block;\n}\n\n.orderUploadPreviewCountText {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    color: var(--common-primary-white-foreground);\n}\n\n.orderUploadPreviewImgRemoveIcon {\n    position: absolute;\n    top: 4px;\n    right: 4px;\n    background: var(--background-primary);\n    box-shadow: 0px 4px 4px 0px #0000000F;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    border-radius: 50%;\n}\n\n\n@media (max-width: 1199px) {\n    .orderCardListContainer {\n        grid-template-columns: 100%;\n        align-items: initial;\n        justify-content: initial;\n    }\n}\n\n@media (max-width: 1199px) and (min-width: 1081px) {\n    .orderUploadImgContainer {\n        grid-template-columns: repeat(5, 1fr);\n        gap: 12px;\n        grid-gap: 12px;\n    }\n}\n\n@media (max-width: 1080px) and (min-width: 991px) {\n    .orderUploadImgContainer {\n        grid-template-columns: repeat(4, 1fr);\n        gap: 12px;\n        grid-gap: 12px;\n    }\n}\n\n@media (max-width: 991px) and (min-width: 768px) {\n    .orderUploadImgContainer {\n        grid-template-columns: repeat(5, 1fr);\n        gap: 12px;\n        grid-gap: 12px;\n    }\n}\n\n@media (max-width: 767px) and (min-width: 576px) {\n    .orderUploadImgContainer {\n        grid-template-columns: repeat(4, 1fr);\n        gap: 18px;\n        grid-gap: 18px;\n    }\n}\n\n@media (max-width: 575px) {\n    .orderUploadImgContainer {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 18px;\n        grid-gap: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orderCardListContainer": `OrderDetails-orderCardListContainer-_lzhT`,
	"orderLocationBox": `OrderDetails-orderLocationBox-hPcNc`,
	"orderUploadImgContainer": `OrderDetails-orderUploadImgContainer-GViVL`,
	"orderUploadImgCardContainer": `OrderDetails-orderUploadImgCardContainer-_zCEs`,
	"orderUploadImgCardPlusIcon": `OrderDetails-orderUploadImgCardPlusIcon-ZWmvv`,
	"orderUploadImgCard": `OrderDetails-orderUploadImgCard-CBq8X`,
	"orderUploadPreviewLoaderContainer": `OrderDetails-orderUploadPreviewLoaderContainer-gBMof`,
	"photoUpdateLoader": `OrderDetails-photoUpdateLoader-RUchz`,
	"orderUploadPreviewImgItem": `OrderDetails-orderUploadPreviewImgItem-pxodP`,
	"orderUploadPreviewImg": `OrderDetails-orderUploadPreviewImg-tKHwd`,
	"orderUploadPreviewOverlay": `OrderDetails-orderUploadPreviewOverlay-hkVtf`,
	"orderUploadPreviewHoverImg": `OrderDetails-orderUploadPreviewHoverImg-UvVJm`,
	"orderUploadPreviewImgHover": `OrderDetails-orderUploadPreviewImgHover-VuKTr`,
	"orderUploadPreviewTextHover": `OrderDetails-orderUploadPreviewTextHover-s_VFl`,
	"orderUploadPreviewCountText": `OrderDetails-orderUploadPreviewCountText-s9Uk2`,
	"orderUploadPreviewImgRemoveIcon": `OrderDetails-orderUploadPreviewImgRemoveIcon-ZgMGy`
};
module.exports = ___CSS_LOADER_EXPORT___;
